export default __webpack_public_path__ + "static/media/dt-money.d82ffe0a.svg";